<template>
  <div class="detail-wrap" style=" overflow-y: scroll;overflow-x: hidden;">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          查看退款单
        </div>
        <div class="fr">
          <el-button type="primary" v-if="formData.stat == 1 && slOrderBackCheck &&formData.id!=null" class="button-sty" icon="el-icon-check" @click="refundCheck(formData.id,formData.backNumber)">审核</el-button>
          <el-button type="primary" v-if="formData.stat != 5 && slOrderBackClose &&formData.id!=null" class="button-sty" icon="el-icon-check" @click="checkAndClose(formData.id)">关闭</el-button>
          <!-- <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button> -->
        </div>
      </div>
      <div>
        <div>
          <!-- 品牌信息 -->
          <div class="d-cont edit-mce-box">
            <div class="d-item">
              <div class="title first">
                <b>主信息</b>
              </div>
              <table class="table-detail">
                <tbody>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      退款单号
                    </th>
                    <td>{{ formData.backNumber }}</td>
                    <th>
                      状态
                    </th>
                    <td v-if="formData.stat==1">待审核</td>
                    <td v-else-if="formData.stat==3">待退款</td>
                    <td v-else-if="formData.stat==5">退款成功</td>
                    <td v-else-if="formData.stat==6">退款失败</td>
                    <td v-else-if="formData.stat==99">关闭</td>
                    <td v-else></td>
                    <!-- <td>
                      <el-select v-model="formData.stat" :disabled="able1">
                        <el-option label="待审核" :value="1" />
                        <el-option label="待退款" :value="3" />
                        <el-option label="退款成功" :value="5" />
                        <el-option label="退款失败" :value="6" />
                        <el-option label="关闭" :value="99" />
                      </el-select>
                    </td> -->
                    <th>
                    分润退回
                    </th>
                    <td v-if="formData.benefitBackStat==1">无分润</td>
                    <td v-else-if="formData.benefitBackStat==2">待退回</td>
                    <td v-else-if="formData.benefitBackStat==3">已退回</td>
                    <td v-else></td>
                    <!-- <td>
                      <el-select v-model="formData.benefitBackStat" :disabled="able1">
                        <el-option label="无分润" :value="1" />
                        <el-option label="待退回" :value="2" />
                        <el-option label="已退回" :value="3" />
                      </el-select>
                    </td> -->
                    <th>
                      <em class="f-red">*</em>
                   销售单号
                    </th>
                   <td>{{ formData.orderNumber }}</td>
                  </tr>
                  <tr>
                    <th>服务商名称</th>
                    <td>{{ formData.siteName }}</td>
                    <th>工程师姓名</th>
                    <td>{{ formData.engineerName }}</td>
                    <th>工号</th>
                    <td>{{ formData.engineerCode }}</td>
                    <th>联系电话</th>
                    <td>{{ formData.engineerMobile }}</td>
                  </tr>
                  <tr>
                    <th>保险审核</th>
                    <td v-if="formData.insureStat==0">无审核</td>
                    <td v-else-if="formData.insureStat==1">审核中</td>
                    <td v-else-if="formData.insureStat==2">同意退保</td>
                    <td v-else-if="formData.insureStat==3">不同意退保</td>
                    <td v-else-if="formData.insureStat==4">审核失败</td>
                    <td v-else></td>
                  </tr>
                  <tr>
                    <th>创建人</th>
                    <td>{{ formData.createBy }}</td>
                    <th>创建时间</th>
                    <td>{{ formData.createTime }}</td>
                    <th>修改人</th>
                    <td>{{ formData.modifyBy }}</td>
                    <th>修改时间</th>
                    <td>{{ formData.modifyTime }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="d-item">
              <div class="title first">
                <b>退款原因</b>
              </div>
              <table class="table-detail">
                <tbody>
                  <tr>
                  <th>退款原因</th>
                  <td colspan="3">{{ formData.backReasonName }}</td>
                  <th>退款备注</th>
                  <td colspan="3">{{ formData.backRemark }}</td>
                </tr>
                  <tr>
                    <th>退款凭证1</th>
                    <td style="display: flex; height: 80px" colspan="6">
                      <div style="display:flex; margin-right: 20px; height: 60px">
                        <el-image v-if="formData.pic1" :preview-src-list="showPhotoList0" :fit="fit"
                          :src="formData.pic1" :initial-index="0"></el-image>
                        <el-image v-else>
                          <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"
                              style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                          </div>
                        </el-image>
                      </div>
                    </td>
                    <th>退款凭证2</th>
                    <td>
                      <div style="display:flex; margin-right: 20px; height: 60px">
                        <el-image v-if="formData.pic2" :preview-src-list="showPhotoList0" :fit="fit"
                          :src="formData.pic2" :initial-index="1"></el-image>
                        <el-image v-else>
                          <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"
                              style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                          </div>
                        </el-image>
                      </div>
                    </td>
                    <th>退款凭证3</th>
                    <td>
                      <div style="display:flex; margin-right: 20px; height: 60px">
                        <el-image v-if="formData.pic3" :preview-src-list="showPhotoList0" :fit="fit"
                          :src="formData.pic3" :initial-index="2"></el-image>
                        <el-image v-else>
                          <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"
                              style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                          </div>
                        </el-image>
                      </div>
                    </td>
                    <th style="visibility: hidden;"></th><td style="visibility: hidden;"></td>

                  </tr>

                </tbody>
              </table>
            </div>

            <div class="d-item">
              <div class="title first">
                <b>退款信息</b>
              </div>
              <table class="table-detail">
                <tbody>
                  <tr>
                    <th>退款交易单</th>
                    <td>{{ formData.wxRefundId }}</td>
                    <th>退款时间</th>
                    <td>{{ formData.wxRefundTime }}</td>
                    <th>退款结果</th>
                    <td>{{ formData.wxRefundResult }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="d-item">
              <div class="title first">
                <b>回传信息</b>
              </div>
              <table class="table-detail">
                <tbody>
                  <tr>
                    <th>退保传单状态</th>
                    <td v-if="formData.sendSurrenderFlag==0">未传单</td>
                    <td v-else-if="formData.sendSurrenderFlag==1">传单失败</td>
                    <td v-else-if="formData.sendSurrenderFlag==2">传单成功</td>
                    <td v-else></td>
                    <th>退保传单时间</th>
                    <td>{{ formData.sendSurrenderDate }}</td>
                    <th>退保传单信息</th>
                    <td>{{ formData.surrenderMessage }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-if="!justShow" style="height:120px"></div>
          </div>
        </div>
      </div>
    </el-form>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
        <span>{{dialogMsg}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>

    <confirmDialogs v-if="confirmCheckDialog" :id="currentRowId" :orderBack="backNumber"
                   :visiable.sync="confirmCheckDialog" multi="true"
                   @goBackIndex="goBackIndex" />

    <!-- <el-image-viewer v-if="dialogVisible" :on-close="closeImgViewer" :url-list="dialogImageUrlList" />

    <sitePop v-if="showSitePop" :visiable.sync="showSitePop" :multi="true" @commit="siteCommit" />

    <orderPop v-if="showOrderPop" :visiable.sync="showOrderPop" multi="false" @commit="orderCommit"
      :siteId="formData.siteId" />

    <closeDialog v-if="showCloseDialog" :close-id="dataId" @closeD="closeD" :visiable.sync="showCloseDialog" multi="true"
      @flushed="editViewDataUpdate" />

    <confirmDialog v-if="showConfirmDialog" :confirmNo="formData.billNo" :dataId="dataId" @closeD="closeD"
      :visiable.sync="showConfirmDialog" multi="true" @flushed="editViewDataUpdate" />

    <auditDialog v-if="showAuditDialog" :dataId="dataId" @closeD="closeD" :visiable.sync="showAuditDialog" multi="true"
      @flushed="editViewDataUpdate" /> -->



  </div>
</template>
<script>
import checkSubjectSearch from "@/components/formItem/checkSubjectSearch.vue"
import Tinymce from '@/components/Tinymce';
import store from "@/store";
import api from '@/api/projectApi'
import { uploadFileFormat, echoFileFormat } from '@/util/uploadFormat'
import sitePop from "@/views/dialogCommon/radioSiteDialog.vue"
import orderPop from '@/views/dialogCommon/radioOrderDialog.vue'
import auditDialog from "@/views/expense/assessment/assessment1/auditDialog.vue";
import confirmDialog from "@/views/expense/assessment/assessment1/confirmDialog.vue";
import closeDialog from "@/views/expense/assessment/assessment1/closeDialog.vue";
import { mapGetters } from "vuex";
import confirmDialogs from '@/views/marketing/order/refund/confirmDialog.vue';

export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    type: String,
  },
  components: {
    checkSubjectSearch,
    closeDialog, confirmDialogs, auditDialog,
    sitePop,
    Tinymce,
    orderPop,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    return {
      justShow: false,
      showCloseDialog: false,
      showConfirmDialog: false,
      showAuditDialog: false,

      dialogImageUrlList: [],
      dialogVisible: false,
      uploadFileUrl: api.uploadFileUrl,
      confirmCheckDialog:false,
      formData: {

        billNo: '',  // 考核单号,前缀"CK"+年月日+6位流水号
        stat: 1,  // 状态：1制单；2.待确认；3待申诉；5已申诉；7执行考核；9已结算；19取消执行；99关闭
        orgId: 0,  // 业务机构，关联脚手架机构表.id
        orgName: '',  // 机构名称,冗余字段
        orgIdPath: '',  // 机构ID路径,冗余字段.重要
        siteId: null,  // 网点ID,关联sn_user.id;
        siteName: '',  // 网点名称,冗余字段
        brandId: '',  // 品牌ID,关联sn_company_brand.id
        brandName: '',  // 品牌名称,冗余字段
        orderId: '',  // 工单id，关联so_order.id.非必填
        orderNo: '',  // 工单号，冗余字段
        // settleId: 0,  // 结算单ID,关联sf_batch_settle.id字段
        checkSubjectId: null,  // 考核科目,关联bas_check_subject.id
        feeAttributeId: '',  // 费用类型,关联sn_company_fee_attribute.id
        feeAttributeName: '',  // 费用类型名称,显示用
        standardAmount: 0,  // 考核金额
        adjustAmount: 0,  // 调整金额
        amount: 0,  // 合计金额:standardAmount+adjustAmount
        proofAttachment1: '',  // 考核凭证1
        proofAttachment2: '',  // 考核凭证2
        proofAttachment3: '',  // 考核凭证3
        isNeedSiteComplain: 1,  // 是否需要网点申诉:0否1是
        siteAnswerDate: '',  // 网点申诉时间
        siteAnswerNote: '',  // 网点申诉意见
        answerAttachment1: '',  // 网点申诉凭证1
        answerAttachment2: '',  // 网点申诉凭证2
        answerAttachment3: '',  // 网点申诉凭证3
        remark: '',  // 考核内容

        picList1: [],
        picList2: [],
        picList3: [],

        checkResult: null, // 审批结果:1申诉成立;2申诉不成立
        checkMan: '',  // 最终审批人
        checkAmount: '',  // 最终审批金额(结算时使用此金额)
        checkDate: '',  // 最终审批时间
        checkNote: '',  // 最终审批意见
      },
      dialogMsg: null,
      dialogVisible: false,
      picList1: [],
      picList2: [],
      picList3: [],
      picList4: [],
      picList5: [],
      picList6: [],
      showPhotoList0: [],
      showPhotoList1: [],
      operationDTOList: [],

      showPhoto: true,
      checkSubjectOption: [],
      brandOptions: [],
      showSitePop: false,

      showProductCategoryDialog: false,
      showOrderPop: false,

      upload_btn1: true,
      upload_btn2: true,
      upload_btn3: true,

      radio: '1',
      showEdit: false,

      activeName: 'first',
      dialog: {
        one: false,
      },

      isEdit: false,
      dataId: '',
    };
  },
  watch: {
    'formData.adjustAmount': {
      handler(newVal, oldVal) {
        if (this.formData.standardAmount !== '' && !this.justShow) {
          let number = Number(this.formData.adjustAmount) + Number(this.formData.standardAmount);
          this.formData.checkAmount = Math.round(number * 100) / 100
          this.formData.amount = this.formData.checkAmount
        }
      },
      deep: true, // 加这个属性，深度监听
    },
    'formData.standardAmount': {
      handler(newVal, oldVal) {
        if (this.formData.adjustAmount !== '' && !this.justShow) {
          let number = Number(this.formData.adjustAmount) + Number(this.formData.standardAmount);
          this.formData.checkAmount = Math.round(number * 100) / 100
          this.formData.amount = this.formData.checkAmount
        }
      },
      deep: true, // 加这个属性，深度监听
    },
    'formData.checkSubjectId': {
      deep: true,
      handler(newVal) {
        this.checkSubjectSelectOne()
      }
    }
  },

  computed: {
    ...mapGetters(["permissions"]),
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      }
    },

  },

  created() {
    this.slOrderBackExport = this.permissions["slOrderBackExport"];
    this.slOrderBackCheck = this.permissions["slOrderBackCheck"];
    this.slOrderBackClose = this.permissions["slOrderBackClose"];
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },

  mounted() {
    this.getData();
    // this.loadBrandOption()
    // this.loadCheckSubjectOption()
  },

  methods: {
    editViewDataUpdate() {
      this.$emit('editViewDataUpdate')
      this.$emit('changeTab')
    },

    //抽屉关闭后改变父组件的visible的值
    closeD(v) {
      this.showConfirmDialog = false
      this.showCloseDialog = false
      this.showAuditDialog = false
      // this.flushed()
    },

    closeImgViewer() {
      this.dialogVisible = false
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrlList = [file.url]
      this.dialogVisible = true
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    showPreconditionDialogFunc() {
      if (this.formData.siteId !== '' && this.formData.siteId !== null)
        this.showOrderPop = true
      else
        this.$message.warning('请先选中网点')
    },

    checkSubjectSelectOne() {
      if (this.formData.checkSubjectId) {
        this.$http.post(api.basCheckSubject.getDataUrl, { id: this.formData.checkSubjectId }).then(res => {
          let data = res.data.data
          this.formData.standardAmount = data.standardAmount
          this.formData.feeAttributeName = data.feeAttributeName
          this.formData.feeAttributeId = data.feeAttributeId
          this.formData.isNeedSiteComplain = data.isNeedSiteComplain
        })
        console.log(this.formData)
      } else {
        this.formData.standardAmount = 0
        this.formData.feeAttributeName = null
        this.formData.feeAttributeId = null
        this.formData.isNeedSiteComplain = null
      }
    },

    loadCheckSubjectOption() {
      this.$http({
        url: api.basCheckSubject.getListUrl,
        method: 'post',
        data: {
          usable: 1,
          useWhere: 1
        }
      }).then(res => {
        this.checkSubjectOption = []
        res.data.data.forEach(item => {
          this.checkSubjectOption.push({
            label: item.name,
            value: item.id,
            feeAttributeId: item.feeAttributeId,
            feeAttributeName: item.feeAttributeName,
            standardAmount: item.standardAmount,
            isNeedSiteComplain: item.isNeedSiteComplain
          })
        })
      })
    },

    brandSelectOne() {
      if (this.formData.brandId !== '') {
        this.brandOptions.forEach(item => {
          if (item.value === this.formData.brandId) {
            this.formData.brandName = item.label
          }
        })
      }
    },

    // 操作
    checkAndClose(command, row) {
        this.dialogMsg = '确定关闭吗？'
        this.stat = 99
        this.dialogVisible = true
    },

    //退款审核
    refundCheck(id,backNumber) {
      this.currentRowId = id
      this.backNumber = backNumber
      this.confirmCheckDialog = true
    },


    confirm() {
      this.$http({
        url: api.refundOrder.confirmDataUrl,
        method: 'post',
        data: {
          id: this.currentRow.id,
          stat: this.stat
        }
      }).then(res => {
        this.$message.success('操作成功')
        this.flushed()
      })
      this.dialogVisible = false
    },

    // 加载品牌
    loadBrandOption() {
      this.$http({
        url: api.snCompanyBrand.getBrandListUrl,
        method: 'post',
        data: {
          usable: 1  // 加载启用的
        }
      }).then(res => {
        this.brandOptions = []
        res.data.data.forEach(item => {
          this.brandOptions.push({
            label: item.brandName,
            value: item.id
          })
        })
      })
    },

    // getOperationData(id) {
    //   this.$http({
    //     url: api.sfCheckBillOperation.getList,
    //     method: 'post',
    //     data: { checkBillId: id }
    //   }).then(res => {
    //     this.operationDTOList = res.data.data
    //   })
    // },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.refundOrder.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data;
          this.formData = data
          this.showPhoto = false
          if (this.justShow) {
            this.showPhotoList0 = [data.proofAttachment1, data.proofAttachment2, data.proofAttachment3]
          } else {
            this.picList1 = echoFileFormat(data.proofAttachment1)
            this.picList2 = echoFileFormat(data.proofAttachment2)
            this.picList3 = echoFileFormat(data.proofAttachment3)
          }
          this.justShow = this.formData.stat != 2
          //流程任务进来的
          if (this.type && this.type == "wf") {
            //只是查看
            this.justShow = true;
          }
          this.showPhoto = true
          this.getOperationData(data.id)
        })
      }
    },
    // saveData() {
    //   this.$refs.editForm.validate(valid => {
    //     if (valid) {
    //       this.$baseConfirm('您确定要保存吗？').then(() => {
    //         this.formData.proofAttachment1 = uploadFileFormat(this.picList1)
    //         this.formData.proofAttachment2 = uploadFileFormat(this.picList2)
    //         this.formData.proofAttachment3 = uploadFileFormat(this.picList3)
    //         this.$mask.open()

    //         this.$http({
    //           url: api.sfCheckBill.saveOrUpdate,
    //           method: `post`,
    //           data: this.formData,
    //           isLoading: true,
    //         }).then(res => {
    //           this.$message.success('保存成功')
    //           this.reload()
    //           this.$mask.close()
    //         }).catch(() => {
    //           this.$message.error("保存失败！");
    //           this.$mask.close()
    //         });
    //       });
    //     }
    //   });
    // },

    // 工单弹窗选中
    orderCommit(row) {
      console.log(row, '弹窗数据')
      this.formData.orderNo = row.orderNo
      this.formData.orderId = row.orderId
    },

    // 网点弹窗选中
    siteCommit(row) {
      console.log(row, '弹窗数据')
      this.formData.siteId = row.id
      this.formData.siteName = row.name

      this.$http({
        url: api.snUser.getMainDataUrl,
        method: 'post',
        data: { id: row.id },
      }).then(res => {
        console.log('网点详情', res)
        this.formData.orgId = res.data.data.snSiteInfoDTO.orgId
        this.formData.orgName = res.data.data.snSiteInfoDTO.orgName
        this.formData.orgIdPath = res.data.data.snSiteInfoDTO.orgIdPath
        console.log(this.formData)
      })
    },

    handleRemove1() {
      this.picList1 = []
    },
    handleSuccess1(res, file, fileList) {
      this.upload_btn1 = false
      console.log(res.data.url, "url")
      this.picList1 = [
        { url: res.data.url }
      ]
    },

    handleRemove2() {
      this.picList2 = []
    },
    handleSuccess2(res, file, fileList) {
      this.upload_btn2 = false
      console.log(res.data.url, "url")
      this.picList2 = [
        { url: res.data.url }
      ]
    },

    handleRemove3() {
      this.picList3 = []
    },
    handleSuccess3(res, file, fileList) {
      this.upload_btn3 = false
      console.log(res.data.url, "url")
      this.picList3 = [
        { url: res.data.url }
      ]
    },

    handleRemove4() {
      this.picList4 = []
    },
    handleSuccess4(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList4 = [
        { url: res.data.url }
      ]
    },

    handleRemove5() {
      this.picList5 = []
    },
    handleSuccess5(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList5 = [
        { url: res.data.url }
      ]
    },

    handleRemove6() {
      this.picList6 = []
    },
    handleSuccess6(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList6 = [
        { url: res.data.url }
      ]
    },
  },
};

</script>
<style lang="scss" scoped>
// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 7vw !important;
}

#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 10vw !important;
  height: 39.2px;
  word-break: break-word;
}

#containt .table-detail tbody tr th {
  // white-space: nowrap;
  width: 7vw !important;
}

::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 80px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 80px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 1px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  // border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 656px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.card_bread {
  position: relative !important;
}



#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}
</style>
